import { useEffect } from 'react'

export function useThemeDocumentEffects(isDarkMode) {
  useEffect(() => {
    const shellColor = isDarkMode ? '#21252b' : '#f0f0f0'

    // Update document theme
    document.documentElement.setAttribute(
      'data-theme',
      isDarkMode ? 'dark' : 'light',
    )
    document.documentElement.style.backgroundColor = shellColor

    // Safari top-bar debug toggle:
    // temporarily do not mutate body background or theme-color.

    function adjustAppHeight() {
      const appHeight = window.innerHeight + 'px'
      document.documentElement.style.setProperty('--app-height', appHeight)
    }

    // Initial adjustment
    adjustAppHeight()

    // Add event listener
    window.addEventListener('resize', adjustAppHeight)

    // Cleanup event listener on component unmount
    return () => {
      window.removeEventListener('resize', adjustAppHeight)
    }
  }, [isDarkMode])
}
